import { useEffect, useMemo, useState } from 'react';
import { DemeterDataFrequency } from '../../../../Generated/Raven-Demeter';
import useLanguage from '../../../Services/Language/useLanguageHook';
import { TrackingEvent } from '../../../Services/Tracking/TrackingService';
import { ITreeNode } from '../../TreeView/TreeItem';
import TreeView from '../../TreeView/TreeView';
import { IPageElementModalSelection } from './PageElementModalDefinitions';

interface IPageElementContractNumberProps {
    selection: IPageElementModalSelection;
    handleDataFrequencySelect: (selected: DemeterDataFrequency) => void;
    availableFrequencies: string;
    track: TrackingEvent;
}

const availableDataFrequencies = [DemeterDataFrequency.Daily, DemeterDataFrequency.Weekly, DemeterDataFrequency.Monthly];

const PageElementDataFrequency: React.FC<IPageElementContractNumberProps> = (props) => {
    const [translations] = useLanguage();
    const [selectedPageType, setSelectedDataFrequency] = useState<DemeterDataFrequency | null>();

    useEffect(() => {
        if (!props.selection.dataFrequency) {
            return;
        }

        setSelectedDataFrequency(props.selection.dataFrequency);
    }, [props.selection.dataFrequency]);

    const treeNodes: ITreeNode[] = useMemo(() => {
        if (!props.availableFrequencies) {
            return [];
        }

        return availableDataFrequencies
            .filter((x) => props.availableFrequencies.includes(x))
            .map((frequency, index) => ({
                id: `${frequency}`,
                name: translations.dataFrequency[frequency],
                value: frequency,
                parentId: '',
                parentValue: '',
                column: 'left',
                selectedProduct: frequency === selectedPageType!,
                expanded: false,
                order: index,
                displayOrder: index,
                children: [],
            }));
    }, [selectedPageType, props.selection, props.availableFrequencies]);

    const handleSelect = (event: React.MouseEvent<HTMLElement>) => {
        const { id } = event.currentTarget;
        const node = treeNodes.find((n) => n.id === id);
        if (node?.id) {
            props.handleDataFrequencySelect(node.value as DemeterDataFrequency);
        }
    };

    return <TreeView data={treeNodes} searchTerm="" handleSelect={handleSelect} disabledNodes={[]} track={props.track} />;
};

export default PageElementDataFrequency;
